<ng-container *ngIf="relativeScheduling; else dateScheduled">
  <div>{{ daysAfterLabel }}</div>
</ng-container>
<ng-template #dateScheduled>
  <div class="session-date">
    <fa-icon *ngIf="dateIcon" [icon]="dateIcon" [fixedWidth]="true"></fa-icon>
    <vnm-date [date]="session.startsAt" dateFormat="MMM dd, y" [showTime]="false"></vnm-date>
  </div>
</ng-template>

<div class="session-time">
  <fa-icon *ngIf="timeIcon" [icon]="timeIcon" [fixedWidth]="true"></fa-icon>
  <vnm-date [date]="session.startsAt" [showDate]="false" timeFormat="hh:mm a"></vnm-date>
  <fa-icon class="time-separator" icon="caret-right" [fixedWidth]="true"></fa-icon>
  <vnm-date [date]="session.endsAt" [showDate]="false" timeFormat="hh:mm a"></vnm-date>
  <span class="session-zone">{{ timeZone }}</span>
</div>
